import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IUpdateFile } from "interfaces";
import { DynamoColumn } from "enums";
import { UpdateTypesService, ManufacturersService, UsersService } from "services";
import { DateTime } from "luxon";
import { useLuxonTimezone } from "hooks";
import { IconButton } from "@cfa/react-components";

interface IListUpdateFileProps {
    updateFile: IUpdateFile;
    onDeleteUpdateFile: (updateFile: IUpdateFile) => void;
}

export const ListUpdateFile: FunctionComponent<IListUpdateFileProps> =
    function ({
        updateFile,
        onDeleteUpdateFile,
    }) {
        const { timezone } = useLuxonTimezone(UsersService.me.timezone);

        const updateTypeName = UpdateTypesService.updateTypesMap[updateFile.updateTypeId]?.description;
        const manufacturerName = ManufacturersService.manufacturersMap[updateFile.manufacturerId]?.name;
        const deviceModels =
            updateFile.deviceModelIds &&
            updateFile.deviceModelIds.map((id) => ManufacturersService.modelsMap[id].name);
        
        function formatDateOnly(dt: DateTime): string {
            return dt.toLocaleString({
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        }

        function formatTimeOnly(dt: DateTime) {
            return dt.toLocaleString({
                weekday: 'short',
                hour: 'numeric',
                minute: '2-digit',
            });
        }

        const createdAtDt = DateTime.fromJSDate(updateFile.createdAt, {zone: timezone});
        const createdAtDateOnly = formatDateOnly(createdAtDt);
        const createdAtTimeOnly = formatTimeOnly(createdAtDt);

        return (
            <div className="updateFiles_listItem">
                <div className="updateFiles_listCol updateFiles_listColMain">
                    <div className="updateFiles_listColSub">
                        <div>
                            <b>Description:</b> {updateFile.description}
                        </div>
                        <div>
                            <b>{manufacturerName} - {updateTypeName} - {updateFile.version}</b>
                        </div>
                        <div>
                            <b>Models:</b> {deviceModels.join(" | ")}
                        </div>
                    </div>
                    <div className="updateFiles_listColSub">
                        <div>
                            <b>S3 Url:</b> {updateFile.s3URL}
                        </div>
                        <div>
                            <b>Success Criteria:</b> {DynamoColumn[updateFile.dynamoAttributeId]}: {"{"}"{updateFile.keyMatcher}" : "{updateFile.version}"{"}"}
                        </div>
                        <div>
                            <b>User Defined:</b> {updateFile.userDefined && JSON.stringify(updateFile.userDefined)}
                        </div>
                    </div>
                </div>
                <div className="updateFiles_listCol updateFiles_listColCreatedAt">
                    <div
                        className="ellipsis"
                        title={createdAtDateOnly + "," + createdAtTimeOnly}
                    >
                        {createdAtDateOnly}
                        <br />
                        {createdAtTimeOnly}
                        <br />
                        by {updateFile.createdBy.name}
                    </div>
                </div>
                <div className="updateFiles_listCol updateFiles_listColAction">
                    <IconButton
                        size="sm"
                        onClick={() => onDeleteUpdateFile(updateFile)}
                    >
                        <FontAwesomeIcon icon="trash" />
                    </IconButton>
                </div>
            </div>
        );
    };
